<template>
  <div class="address-manage">
    <div class="box" id="user-input">
      <div class="form-container">
        <div class="form-body">
          <field placeholder="请输入姓名" label="姓名：" v-model="userName"></field>
          <field placeholder="请输入手机号" label="电话：" v-model="userTel" type="number"></field>
          <div class="cell-field">
            <cell cellName="选择收货城市：">
              <div slot="value" @click="addressFlag = true" class="city-picker-area">
                <span>{{addressValue}}</span>
                <img src="@/assets/right-chevron.png" alt="more">
              </div>
            </cell>
          </div>
          <field placeholder="街道、楼牌号等" label="详细地址：" v-model="detailAddr"></field>
        </div>
      </div>
    </div>

    <div class="preview-box">
      <h3>地址信息预览</h3>

      <div class="box" style="margin: 0;">
        <div class="form-container">
          <div class="form-body">

            <div class="_row row_01">
              <span v-if="userName">{{userName}}</span>
              <span v-else class="preview">收件人</span>
              <span v-if="userTel">{{userTel}}</span>
              <span v-else class="preview">联系电话</span>
            </div>
            <div class="_row">
              <template v-if="addressValue || detailAddr">
                {{addressValue}} {{detailAddr}}
              </template>
              <template v-else>
                <span class="preview">收件地址</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div @touchmove.prevent>
      <mt-popup v-model="addressFlag"
                :modalFade="true"
                :lockScroll="true"
                :close-on-click-modal="true"
                popup-transition="popup-fade"
                position="bottom"
                class="mint-popup">
        <mt-picker :slots="slots"
                   value-key="value"
                   :visible-item-count="7"
                   :show-toolbar="true"
                   ref="picker"
                   class="address-pick"
                   @change="onValuesChange">
          <div @click="handleConfirm" class="sure">确认</div>
        </mt-picker>
      </mt-popup>
    </div>

    <div class="btn-container" id="btn-save">
      <button class="btn btn-primary" @click="useAddress">保存并使用</button>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import {STORAGE_CURR_ADDR, STORAGE_ADDRESS_INFO} from '../utils/const'

  import Field from '../components/Form/Field'
  import Cell from '../components/Form/Cell'

  import {Toast,Picker,Popup} from 'mint-ui'

  import Vue from 'vue';

  Vue.component(Picker.name, Picker)
  Vue.component(Popup.name, Popup)

  export default {
    components: {Field, Cell},
    data() {
      return {
        addressCode: '',
        mrpId: '',
        mrcid: '',
        addressFlag: false,
        addressValue: '',
        addressValuePlaceholder: '',
        city: [],
        area: [],
        userName: '',
        userTel: '',
        detailAddr: '',
        addrData: null,
        addressSlots: [],
        areaCode: '',

        slots: [
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'right',
            defaultIndex: 0
          }, {
            flex: 1,
            values: [],
            className: 'slot2',
            textAlign: 'center',
            defaultIndex: 0
          }, {
            flex: 1,
            values: [],
            className: 'slot3',
            textAlign: 'left',
            defaultIndex: 0
          }
        ],
        currPickerValues: [],
      };
    },
    activated() {
      this.getStoredAddr()
      this.initData()
    },
    deactivated(){
      this.$root.$off('modifyorder')
    },
    methods: {
      ...mapActions(['getDivisions','checktxt']),
      // 从本地缓存获取上次选择后的地址信息
      getStoredAddr() {
        //未支付订单回归修改地址
        let order = this.$route.params.order
        if(order){
          console.log("修改地址:::",order)
          let {user_address_division,user_name,user_phone,user_address_detail,user_address} = order
          let user_address1 = user_address.replace(/(\s)*\/(\s*)/g, '').replace(user_address_detail,'')
          this.addressCode=user_address_division
          this.userName=user_name
          this.userTel=user_phone
          this.detailAddr=user_address_detail
          this.addressValue = user_address1
          this.currPickerValues = [0, 0, 0]
        }else{
          ({ // init last data;
            values: this.currPickerValues,
            detailAddr: this.detailAddr,
            addressValue: this.addressValue,
            userTel: this.userTel,
            userName: this.userName,
            addressCode: this.addressCode,
          } = (JSON.parse(localStorage.getItem(STORAGE_CURR_ADDR)) || {values: [0, 0, 0]}));
        }
      },

      /**
       * 获取地址列表
       * @returns {Promise<any>|Promise<*[][] | AxiosResponse<any>>}
       */
      getAddr() {
        if (window.sessionStorage) {
          const addrInfo = JSON.parse(window.sessionStorage.getItem(STORAGE_ADDRESS_INFO))

          if (addrInfo && addrInfo.data) {
            const needRefresh = (+new Date() - +addrInfo.time_str) > (5 * 60 * 1000)

            if (!needRefresh) {
              console.log('get addr list from local')
              return Promise.resolve(addrInfo.data)
            }

            console.log('data not fresh!')
          }
        }

        console.log('get addr list from sereve')
        return this.getDivisions()
          .then(res => {
            let data = {...res.data.description[0],...res.data.description[1],...res.data.description[2]};
            let province_list = []
              , city_list = []
              , area_list = []
              , addr_data = []

            for (let key in data) {
              if (+key === 710000 || +key === 810000 || +key === 820000) {
                continue;
              }
              let value = data[key]
              if (/0000$/.test(key)) {
                province_list.push({key, value,})
              } else if (/00$/.test(key)) {
                city_list.push({key, value,})
              } else {
                area_list.push({key, value,})
              }
            }
            addr_data = [[...province_list], [...city_list], [...area_list]]

            const saveData = {data: addr_data, time_str: +new Date(),}

            try {
              window.sessionStorage.setItem(STORAGE_ADDRESS_INFO, JSON.stringify(saveData))
            } catch (e) {
              console.log(e);
            }

            console.log('update success')
            return addr_data
          })
      },

      // 初始化 picker 的数据
      initData() {
        return this.getAddr()
          .then(data => {
            let all_provinces = data[0]   // 省 列表
              , all_cities = data[1]      // 市 列表
              , all_areas = data[2]       // 区 列表

              , province_code             // 选中的省 代码序号
              , cities                    // 选中的省 城市列表
              , city_code                 // 选中的城市 代码序号
              , areas                     // 选中的城市 区域列表
              , multiIndex = [0, 0, 0]
              , no_area = false


            const getProvinceCode = (p_item) => p_item.key.slice(0, 2)
            const getCityCode = (c_item) => c_item.key.slice(0, 4)

            // set default cities
            const curr = this.currPickerValues;

            if (curr[0] && curr[0].key) { // set default province
              const province_index = all_provinces.findIndex(item => item.key === curr[0].key)
              province_index === -1 && (province_index = 0)
              this.slots[0].defaultIndex = multiIndex[0] = province_index
            }

            province_code = getProvinceCode(all_provinces[multiIndex[0]])
            cities = all_cities.filter(item => getProvinceCode(item) === province_code)
            if (!cities.length) { // 没有城市，有区域
              no_area = true
              cities = all_areas.filter(item => getProvinceCode(item) === province_code)
            }

            areas = []
            if (cities.length && !no_area) {
              if (curr[1] && curr[1].key) { // set default city
                const city_index = cities.findIndex(item => item.key === curr[1].key)
                city_index === -1 && (city_index = 0)
                this.slots[1].defaultIndex = multiIndex[1] = city_index
              }

              city_code = getCityCode(cities[multiIndex[1]])
              areas = all_areas.filter(item => getCityCode(item) === city_code)
              if (curr[2] && curr[2].key) {
                const area_index = areas.findIndex(item => item.key === curr[2].key)
                this.slots[2].defaultIndex = multiIndex[2] = area_index
              }
            }

            this.slots[0].values = all_provinces;
            this.slots[1].values = cities;
            this.slots[2].values = areas;

            this.city = all_cities;
            this.area = all_areas;

            // this.mrpId = all_provinces[0].key
            this.mrpId = this.currPickerValues[0].key
            // this.mrcid = cities[0].key
            this.mrcid = this.currPickerValues[1].key
          })
      },

      handleConfirm() {
        this.$nextTick(_ => {
          let curr_province = this.$refs.picker.getSlotValue(0)
          let curr_city = this.$refs.picker.getSlotValue(1)
          let curr_area = this.$refs.picker.getSlotValue(2)
          //特别行政区
          if (curr_city === undefined) {
            this.addressValue = curr_province.value
            this.addressCode = curr_province.key
          } else if (curr_area === undefined) {
            //直辖市
            this.addressValue = curr_province.value + curr_city.value
            this.addressCode = curr_city.key
          } else {
            //普通
            this.addressValue = curr_province.value + curr_city.value + curr_area.value
            this.addressCode = curr_area.key
          }
        })
        this.addressFlag = false
      },

      onValuesChange(picker, values) {
        if (values[0] !== undefined) {
          if (this.mrpId != values[0].key) {
            let province_code = values[0].key.slice(0, 2)
            let city = this.city.filter(item => {
              return item.key.slice(0, 2) === province_code
            })
            if (city.length === 0) {
              city = this.area.filter(item => item.key.slice(0, 2) === province_code)
              picker.setSlotValues(2, city);
            }
            picker.setSlotValues(1, city);
            this.mrpId = values[0].key;
            this.mrcid = values[1] !== undefined ? values[1].key : 0;
          }
        }
        if (values[1] !== undefined) {
          if (this.mrcid != values[1].key) {
            if (/00$/.test(values[1].key)) {
              let city_code = values[1].key.slice(0, 4)
              let area = this.area.filter(item => {
                return item.key.slice(0, 4) === city_code
              })
              picker.setSlotValues(2, area);

            } else {
              picker.setSlotValues(2, []);
            }

            this.mrpId = values[0].key;
            this.mrcid = values[1].key;
          }
        }

        this.currPickerValues = values
      },

      useAddress() {
        if (!this.isValidPhone) {
          Toast('请输入正确的手机号');
        } else if (!this.isValidName) {
          Toast('请输入姓名');
        } else if (!this.isValidCity) {
          Toast('请选择收货城市');
        } else if (!this.isValidDetailAddr) {
          Toast('请输入详细地址');
        } else {
        this.checktxt(`${this.userName}+${this.detailAddr}`).then(res=>{
          //判断是否是从修改地址进来
            if(this.$route.params.order){
              let data = {
                orderid:this.$route.params.order.id,
                user_address_division:this.addressCode,
                user_name:this.userName,
                user_phone:this.userTel,
                user_address_detail:this.detailAddr
              }
              this.$root.$emit('modifyorder',data)
            }else{
              localStorage.setItem(STORAGE_CURR_ADDR,
                JSON.stringify({
                  userName: this.userName,
                  userTel: this.userTel,
                  addressValue: this.addressValue,
                  addressCode: this.addressCode,
                  detailAddr: this.detailAddr,
                  values: this.currPickerValues
                })
              );
              Toast('保存成功！')
            }
          this.$router.go(-1) 
        })
          
        }
      },
    },

    computed: {
      isValidPhone() {
        return /^1[0-9]{10}$/.test(this.userTel);
      },
      isValidName() {
        return this.userName;
      },
      isValidCity() {
        return this.addressCode;
      },
      isValidDetailAddr() {
        return this.detailAddr;
      },
    },
  };
</script>

<style scoped lang="scss">
  .address-manage {
    width: 100vw;
    min-height: 100vh;
    padding-top: 0.16rem;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;


    .preview-box {
      margin: 0.16rem 0.16rem 0;

      h3 {
        color: rgba(54, 54, 54, 1);
        font-size: 0.14rem;
        margin-bottom: 0.08rem;
      }

      .box {
        background-color: rgba(248, 250, 254, 1);
        box-shadow: none;

        .form-body {
          padding: 0.12rem 0.16rem;
          font-size: 0.14rem;
          color: #363636;
          overflow: hidden;

          ._row {
              word-break: break-all;

            .preview {
              color: rgba(9, 9, 9, 0.15);
            }

            &.row_01 {
              span + span {
                margin-left: 0.18rem;
              }
            }
          }

          ._row + ._row {
            margin-top: 0.08rem;
          }
        }
      }
    }

    #user-input {
      margin-top: 0;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: none;

      .form-body {
        padding: 0 0.09rem;
        .cell-field + .cell-field {
          border-top: 1px solid rgba(151, 151, 151, 0.15);
        }
      }
    }
  }

  #user-input {
    margin-top: 0.16rem;
  }

  #btn-save {
    position: fixed;
    bottom: 0.24rem;
    width: 3.19rem;
    padding: 0;
    left: 0.28rem;

    button {
      font-size: 0.14rem;
    }
  }

  .sure {
    float: right;
    color: red;
    margin-right: 0.2rem;
    height: 100%;
    width: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .address-pick {
    width: 100vw;
  }

  .address-gray {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    z-index: 2000;
  }

  .city-picker-area {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 0.11rem;
      height: 0.11rem;
      object-fit: contain;
    }
  }

</style>

<style lang="scss">
  @import "../style/index";
  .address-manage .picker-slot {
    font-size: 0.14rem !important;
  }

  .address-manage input::-webkit-input-placeholder {
    color: rgba(9, 9, 9, 0.15) !important;
  }
  .form-body .cell-field input {
      font-size: 0.14rem!important;
  }
</style>